<script>
    import { onDestroy } from 'svelte';
    import { showLoader } from '@repo/stores/Actions';
    import EarthModel from './EarthModel.svelte';

    let show = $state('Loading...');
    

    const unsubscribeShowLoader = showLoader.subscribe(s => show = s);

    onDestroy(() => {
        try {
            unsubscribeShowLoader();
        } catch (err) {
            console.error(err);
        }
    });

</script>

{#if show}
<div class="loading-shield">
    <EarthModel />
    <img class="loader-progress" src="/ui/loader.svg" alt="">
    <img class="loader-logo" src="/tenant/biozone-world-white.svg" alt="Biozone World Logo">
    <span role="status" class="message">{show}</span>
</div>
{/if}

<style>
    .loading-shield{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:center;
        background-color:black;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:100000;
    }

    .loader-progress{
        position:absolute;
        width:15rem;
    }

    .loader-logo{
        position:absolute;
        width:8rem;
    }

    .message{
        position:absolute;
        margin-top:18rem;
        text-transform: capitalize;
        font-size:0.9rem;
        color:#666;
    }
</style>